/**
 * @module language/actions
 */

import axios from 'axios'
import { API_URL, ALL_LANGS } from '../constants'
import moment from 'moment'
// import locale file(s)
import 'moment/locale/da'
import 'moment/locale/en-gb'
import 'moment/locale/sv'
import 'moment/locale/nn'

import EventEmitter from '../utils/events'

/**
 * @description Returns payload for dispatching REDUX_I18N_SET_LANGUAGE
 * @param {String} lang Language representation string to switch to
 */
export function setLanguageAction (lang) {
  return {
    type: 'REDUX_I18N_SET_LANGUAGE',
    lang
  }
}

/**
 * @description Returns payload for dispatching REDUX_I18N_SET_TRANSLATIONS
 * @param {Object} translations Object containing all the translations
 */
export function setTranslationsAction (translations) {
  return dispatch => {
    dispatch({
      type: 'REDUX_I18N_SET_TRANSLATIONS',
      translations
    })
    // Makes Search/workcard to be called multiple times on reloads
    // EventEmitter.emit('FORCE_UPDATE')
  }
}

export function setLanguages (languages) {
  return dispatch => {
    dispatch({
      type: 'REDUX_I18N_SET_LANGUAGES',
      languages
    })
  }
}

/**
 * @description Sets a new language
 * @param {String} lang Language representation string to switch to
 */
export function setLanguage (lang) {
  return dispatch => {
    window.localStorage.setItem('user_language', lang)
    // Set locale for moment
    let locale = 'en'
    switch (lang) {
      case 'Danish':
        locale = 'da'
        break
      case 'English':
        locale = 'en-gb'
        break
      case 'Swedish':
        locale = 'sv'
        break
      case 'Norwegian':
        locale = 'nn'
        break
    }
    moment.locale(locale, {
      week: {
        dow: 1
      }
    })

    dispatch(setLanguageAction(lang))
    EventEmitter.emit('USER_CHANGED_LANG')
  }
}

/**
 * @description Sets language to the next
 */
export function setNextLanguage (currentLang) {
  return dispatch => {
    let allLangs = getLanguages()
    let currentLangIndex = 0
    for (let i = 0; i < allLangs.length; i++) {
      if (allLangs[i] === currentLang) {
        currentLangIndex = i
      }
    }
    let nextLangIndex = currentLangIndex + 1
    if (nextLangIndex >= allLangs.length) {
      nextLangIndex = 0
    }
    let nextLang = allLangs[nextLangIndex]
    window.localStorage.setItem('user_language', nextLang)
    dispatch(setLanguageAction(nextLang))
  }
}

/**
 * @description Get all languages
 */
export function getLanguages () {
  let langs = ['Danish', 'English', 'Swedish', 'Norwegian']
  return langs
}

/**
 * @description Get all language infos
 */
export function getLanguageInfos () {
  return dispatch => {
    return ALL_LANGS
  }
}

/**
 * @description Get all language info
 */
export function getLanguageInfo (lang) {
  return dispatch => {
    let langs = ALL_LANGS
    let langInfo
    for (let i = 0; i < langs.length; i++) {
      if (langs[i].LanguageName === lang) {
        langInfo = langs[i]
      }
    }
    if (langInfo === undefined) {
      langInfo = langs[0]
    }
    return langInfo
  }
}

/**
 * @description Sets new translations
 * @param {String} lang Language representation string to switch to
 */
export function setTranslations (translations) {
  return dispatch => {
    dispatch(setTranslationsAction(translations))
  }
}

/**
 * @description Fetches translations from server and dispatching setTranslations
 */
export function InitLanguage () {
  return new Promise((resolve, reject) => {
    let translations = {}
    // axios.get(API_URL + '/Resources/Get').then((res) => {
    //   let languages = res.data.Languages

    let globalResource = window.localStorage.getItem('globalResource') // getting globalResource from localStorage
    let globalHash = window.localStorage.getItem('globalHash') // getting globalHash from localStorage
    if (globalResource == null || globalHash == null) { // If globalResource/globalHash is null then get data
      axios.get(API_URL + '/Resources/Get').then((res) => {
        let languages = res.data.Languages
        let langs = []
        languages.forEach((val, index) => {
          langs.push(val.Name)
          let cultureTranslations = {}
          val.Dictionaries.map((dictionary, index) => {
            cultureTranslations[dictionary.ID] = dictionary.Value
          })
          translations[val.Name] = cultureTranslations
        })
        window.localStorage.setItem('globalHash', res.data.ResourceHash)
        window.localStorage.setItem('globalResource', JSON.stringify(res.data))
        let data = {
          data: res.data,
          translations: translations,
          langs: langs
        }
        resolve(data)
      }, (err) => {
        reject(err)
      })
    } else { // if globalResource/globalHash exist use those data.
      let languages = JSON.parse(globalResource).Languages
      let langs = []
      languages.forEach((val, index) => {
        langs.push(val.Name)
        let cultureTranslations = {}
        val.Dictionaries.map((dictionary, index) => {
          cultureTranslations[dictionary.ID] = dictionary.Value
        })
        translations[val.Name] = cultureTranslations
      })
      let data = {
        data: JSON.parse(globalResource),
        translations: translations,
        langs: langs
      }
      resolve(data)

      axios.post(API_URL + '/Resources/CheckHash', '{Hash:\'' + globalHash + '\'}').then((res) => {
        if (!res.data.Match) {
          let languages = res.data.Resources.Languages
          let langs = []
          languages.forEach((val, index) => {
            langs.push(val.Name)
            let cultureTranslations = {}
            val.Dictionaries.map((dictionary, index) => {
              cultureTranslations[dictionary.ID] = dictionary.Value
            })
            translations[val.Name] = cultureTranslations
          })
          let data = {
            data: res.data.Resources,
            translations: translations,
            langs: langs
          }
          window.localStorage.setItem('globalHash', res.data.Resources.ResourceHash)
          window.localStorage.setItem('globalResource', JSON.stringify(res.data.Resources))
          resolve(data)
        }
      }, (err) => {
        console.log(err)
      })
    }
  })
}




// WEBPACK FOOTER //
// ./src/app/language/actions.js